import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d55f02c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-4" }, "Hashing Tools", -1))
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<option value=\"MD5\" data-v-1d55f02c>MD5</option><option value=\"SHA1\" data-v-1d55f02c>SHA-1</option><option value=\"SHA256\" data-v-1d55f02c>SHA-256</option><option value=\"SHA384\" data-v-1d55f02c>SHA-384</option><option value=\"SHA512\" data-v-1d55f02c>SHA-512</option><option value=\"SHA3\" data-v-1d55f02c>SHA-3</option>", 6)
const _hoisted_11 = [
  _hoisted_5
]
const _hoisted_12 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_13 = { class: "p-4 bg-slate-900 border border-slate-700 rounded-lg text-slate-300 overflow-x-auto" }
const _hoisted_14 = { class: "text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputText) = $event)),
        class: "w-full h-32 p-3 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50",
        placeholder: "Enter text here"
      }, null, 512), [
        [_vModelText, _ctx.inputText]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAlgorithm) = $event)),
        class: "w-full p-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
      }, _hoisted_11, 512), [
        [_vModelSelect, _ctx.selectedAlgorithm]
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generateHash && _ctx.generateHash(...args))),
      class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
    }, " Generate Hash "),
    (_ctx.generatedHash)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, [
            _createTextVNode("Generated Hash: "),
            _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.generatedHash), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}